<template>
  <v-menu
    ref="menu"
    class="WBUDDateCell"
    v-model="dateMenu"
    style="z-index: 10000"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    z-index="999"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        clearable
        :value="input[cellKey]"
        :label="getTitle(cell)"
        prepend-icon="mdi-calendar"
        @click:clear="input[cellKey] = null"
        @click:prepend="on.click"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker show-week show-current first-day-of-week="1" :value="value" @input="dateMenu = false" @change="(v) => onDateSelect(v, cellKey)" />
  </v-menu>
</template>

<script>
import dateUtils from '../../../common/dateUtils';
import dateTimeMixin from '../../../mixins/dateTimeMixin';
import { getTitle } from './wb-common';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  mixins: [dateTimeMixin],
  data() {
    return {
      dateMenu: false,
      getTitle,
    };
  },
  created() {
    if (this.cell.cellName === 'UDDateCell') {
      // UDDateCell should initially show the current date (and be reactive)
      // It is not wanted to set the current date as the default (namely mentionned by lvb)
      // this.$set(this.input, this.cellKey, dateUtils.formatAsLocaleShortDate(new Date()));
    }

    this.makeShortYearLong(this.input[this.cellKey], this.cellKey);
  },
  computed: {
    input() {
      return this.$store.state[this.namespace].formInput;
    },
    cellKey() {
      return this.cell.key + this.mIndex;
    },
    // The value used for the date-picker {string} in yyyy-mm-dd format
    value() {
      const cellValue = this.input[this.cellKey];
      if (!cellValue) return null;

      let germanLocaleDateParts = cellValue.split('.');
      let dd = Number(germanLocaleDateParts[0]);
      let mm = Number(germanLocaleDateParts[1]) - 1;
      let yyyy = Number(germanLocaleDateParts[2]);
      let date = new Date(yyyy, mm, dd);

      return this.input[this.cellKey] ? date.toISOString().substring(0, 10) : null;
    },
  },
  methods: {
    onDateSelect(yyyymmdd, key) {
      // Dates are getting stored within the database table wagenbuch_report_item.value in the format DD.MM.YYYY
      // this.input is the data model which is sent to the server thus dates must be stored in DD.MM.YYYY format too
      this.$set(this.input, key, dateUtils.formatAsLocaleLongYearDate(new Date(yyyymmdd)));
    },
    makeShortYearLong(formattedDateStr, key) {
      const dateParts = formattedDateStr ? formattedDateStr.split('.') : [];

      if (dateParts.length === 3) {
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        if (year.length === 2) {
          this.$set(this.input, key, `${day}.${month}.20${year}`);
        }
      }
    },
  },
};
</script>
